import React, { useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/UserContext";

export default function Home() {
    const navigate = useNavigate();
    const { userData } = useContext(UserContext);

    useEffect(() =>{
        if (!userData.token) navigate('/admin/login');
    }, [navigate, userData.token]);

    return (
        <div className="page">
            <h1>Servicio de Archivo de GN4</h1>
        </div>
    )
}